import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", {
  class: "title is-2 has-text-centered",
  "data-aos": "fade-right"
}, "About me", -1)
const _hoisted_2 = { class: "container timeline" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "marker" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "timeline-content",
  "data-aos": "fade-left"
}
const _hoisted_5 = {
  key: 1,
  class: "timeline-content",
  "data-aos": "fade-right"
}


export default /*#__PURE__*/_defineComponent({
  __name: 'VerticalTimeLine',
  setup(__props) {

const events = [
  {
    date: "Jan2024 - Currently",
    title: "Star pursuing a degree",
    subtitle: "Degree: Informatic Engineering",
    description: "",
    icon: "fas fa-graduation-cap",
  },
  {
    date: "Au2021 - Jan/2024",
    title: "Worked at Vass",
    subtitle: "Position: Web Developer",
    description: "",
    icon: "fas fa-briefcase",
  },
  {
    date: "Abr/2020 - Jul/2022",
    title: "Graduated from Sena",
    subtitle: "Associate's Degree: Technologist Analysis of Information System",
    description: "",
    icon: "fas fa-graduation-cap",
  },
  {
    date: "Dec/2019 - Mar/2021",
    title: "Worked at Intevo",
    subtitle: "Position: Web Developer",
    description: "",
    icon: "fas fa-briefcase",
  },
  {
    date: "Apr/2019 - Nov/2019",
    title: "Worked at Soulmedical",
    subtitle: "Position: Web Developer",
    description: "",
    icon: "fas fa-briefcase",
  },
  {
    date: "Oct/2018 - Nov/2019",
    title: "Graduated from Sena",
    subtitle: "Associate's Degree: Technical Software Developer",
    description: "",
    icon: "fas fa-graduation-cap",
  },
  {
    date: "Oct/2017 - Dec/2018",
    title: "Worked at ConexTravel",
    subtitle: "Position: Web Developer",
    description: "",
    icon: "fas fa-briefcase",
  },
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(events, (event, index) => {
        return _createElementVNode("div", {
          key: index,
          class: _normalizeClass(["timeline-block", {
        'timeline-block-right': index % 2 !== 0,
        'timeline-block-left': index % 2 === 0,
      }])
        }, [
          _hoisted_3,
          (index % 2 !== 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                _createElementVNode("i", {
                  class: _normalizeClass(event.icon)
                }, null, 2),
                _createElementVNode("h5", null, [
                  _createTextVNode(_toDisplayString(event.title) + " ", 1),
                  _createElementVNode("small", null, _toDisplayString(event.date), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(event.subtitle), 1),
                _createElementVNode("p", null, _toDisplayString(event.description), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("i", {
                  class: _normalizeClass(event.icon)
                }, null, 2),
                _createElementVNode("h5", null, [
                  _createTextVNode(_toDisplayString(event.title) + " ", 1),
                  _createElementVNode("small", null, _toDisplayString(event.date), 1)
                ]),
                _createElementVNode("span", null, _toDisplayString(event.subtitle), 1),
                _createElementVNode("p", null, _toDisplayString(event.description), 1)
              ]))
        ], 2)
      }), 64))
    ])
  ], 64))
}
}

})